import {Grid} from "@material-ui/core";
import {FiCheckCircle, FiFile, FiFileText, FiXCircle} from "react-icons/fi";
import {useResourceContext} from "react-admin";
import {useQuery} from "react-query";
import {stringify} from "querystring";

import {StatCard} from "../../components/StatCard";
import {client} from "../../dataProvider";
import {useListQueryParams} from "../../shared/hooks/useListQueryParams";
import {formatThousandsNumber} from "../../shared/utils";

export const NoteImportListHeader = () => {
    const resource = useResourceContext();
    const query = useListQueryParams();
    const url = `${resource}/statistics/?${stringify(query)}`;
    const {data: stats} = useQuery([url], () => client(url, {method: "GET"}), {
        initialData: {imports: 0, files: 0, assigned_files: 0, unassigned_files: 0},
    });

    return <Grid container style={{paddingTop: 0, paddingBottom: 0, position: "sticky", top: 0, zIndex: 1000, backgroundColor: "white"}}>
        <Grid item style={{width: "25%"}}>
            <StatCard label={formatThousandsNumber(stats.imports)} icon={<FiFileText/>} subtitle="Import"/>
        </Grid>
        <Grid item style={{width: "25%"}}>
            <StatCard label={formatThousandsNumber(stats.files)} icon={<FiFile/>} subtitle="Bolle"/>
        </Grid>
        <Grid item style={{width: "25%"}}>
            <StatCard color={"green"} label={formatThousandsNumber(stats.assigned_files)} icon={<FiCheckCircle/>} subtitle="Bolle assegnate"/>
        </Grid>
        <Grid item style={{width: "25%"}}>
            <StatCard color={"red"} label={formatThousandsNumber(stats.unassigned_files)} icon={<FiXCircle/>} subtitle="Bolle non assegnate"/>
        </Grid>
    </Grid>;
};
